<template>
    <app-layout>

        <section
            class="shadow-sm bg-white rounded-lg pt-4 pb-2 px-6 w-full md:w-1/2"
        >
            <select-input
                v-model="selectedCountry"
                label="Country"
                :options="countryOptions"
                @input="searchCountry"
                class="mb-5"
                :error="errors['country_id'] ? errors['country_id'][0] : ''"
            />

            <select-input
                v-model="selectedType"
                label="Package type"
                :options="packageTypeOptions"
                class="mb-5"
            />

            <text-input
                v-model="form.name"
                label="Name"
                class="mb-5"
                :error="errors['name'] ? errors['name'][0] : ''"
            />

            <textarea-input
                v-model="form.description"
                label="Description"
                class="mb-5"
                :error="errors['description'] ? errors['description'][0] : ''"
            />

            <number-input
                v-model="form.price"
                label="Price $"
                class="mb-5"
            />

            <text-input
                v-model="form.offering_code"
                label="Offering Code"
                class="mb-5"
            />

            <text-input
                v-model="form.offering_id"
                label="Offering ID"
                class="mb-5"
            />

            <textarea-input
                v-model="form.note"
                label="Note"
                class="mb-5"
            />

            <button-input
                text="Update"
                :loading="loading"
                :disabled="loading"
                @click="submit"
            />
        </section>
    </app-layout>
</template>

<script>

import AppLayout from "../../layouts/AppLayout.vue";
import EditView from "../../components/views/edit/Index.vue";
import {mapGetters} from "vuex";
import TextInput from "@/components/ui/inputs/TextInput.vue";
import SelectInput from "@/components/ui/inputs/SelectInput.vue";
import TextareaInput from "@/components/ui/inputs/TextareaInput.vue";
import NumberInput from "@/components/ui/inputs/NumberInput.vue";
import ButtonInput from "@/components/ui/inputs/ButtonInput.vue";
import _ from "lodash";

export default {
    name: "CountryPackagesEdit",

    components: {
        ButtonInput, NumberInput, TextareaInput, SelectInput, TextInput,
        EditView,
        AppLayout
    },

    data() {
        return {
            loading: false,
            countryOptions: [],
            packageTypeOptions: [
                {name: 'Day', value: 'day'},
                {name: 'Month', value: 'month'},
            ],
            selectedCountry: {},
            selectedType: {},
            form: {
                name: '',
                description: '',
                price: 0.0,
                note: '',
                index: 0,
                offering_code: '',
                offering_id: '',
            },
            errors: {}
        }
    },

    computed: {
        ...mapGetters({
            model: 'country-packages/getModel',
        })
    },

    created() {
        this.init();
    },

    methods: {
        init() {
            this.loadEditData();
            this.searchCountry('');
        },

        searchCountry: _.debounce(function (value) {
            this.$store.dispatch("countries/search", {
                keywords: value,
                limit: 10
            }).then(res => {
                this.countryOptions = res.data;
            }).catch(error => {
                this.$toast.warning(error.data.message);
            });
        }, 300),

        submit() {
            this.loading = true;

            let formData = this.form;
            formData.id = this.$route.params.id;
            formData.country_id = this.selectedCountry.id;
            formData.package_type = this.selectedType.value;

            this.$store.dispatch(`country-packages/update`, formData)
                .then(() => {
                    this.$router.push(`/country-packages`);
                    this.loading = false;
                })
                .catch(error => {
                    this.$toast.warning(error.data.message);
                    this.errors = error.data.errors;
                    this.loading = false;
                });
        },

        loadEditData() {
            this.$store.dispatch("country-packages/getEditData", this.$route.params.id)
                .then(res => {
                    let plan = res.data;

                    this.form = {
                        name: plan.name,
                        description: plan.description,
                        price: plan.price,
                        note: plan.note,
                        index: plan.index,
                        offering_code: plan.offering_code,
                        offering_id: plan.offering_id,
                    }
                    this.selectedCountry = plan.country;
                    this.selectedType = this.packageTypeOptions.find(type => {return type.value === plan.package_type});
                    this.loading = false;
                })
                .catch(error => {
                    this.$toast.warning(error.data.message);
                    this.loading = false;
                });
        }
    }
};
</script>
